import React, { useEffect, useState } from "react";


import Swal from "sweetalert2"; 
import {
  deleteBanner,
  getBanners,
  postBanner,
  updateBanner,
} from "../utils/Api/ApiCalls";


const Banners = () => {
  const [banners, setBanners] = useState([]);
  const [bottomAds, setBottomAds] = useState([]);
  const [loading, setLoading] = useState(false);

  // Use a placeholder for baseURL in this environment
  const baseURL = "https://backend.argone.ng"; 
  const HERO_BANNER_WIDTH = 1313;
  const HERO_BANNER_HEIGHT = 501;
  const BOTTOM_AD_WIDTH = 880; 
  const BOTTOM_AD_HEIGHT = 566;

  // --- State for Hero Banner (Existing) ---
  const [newBanner, setNewBanner] = useState({ file: null, link: "" });
  const [preview, setPreview] = useState("");
  const [editing, setEditing] = useState(null);

  // --- State for Bottom Ad (New) ---
  const [newBottomAd, setNewBottomAd] = useState({ file: null, link: "" });
  const [previewBottomAd, setPreviewBottomAd] = useState("");
  const [editingAd, setEditingAd] = useState(null); // NEW: State for editing bottom ad

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        setLoading(true);
        const response = await getBanners(); 

        console.log(response);
        

        // Filter banners by type
        const hero = response.filter((banner) => banner.type === "hero");
        const bottomAds = response.filter(
          (banner) => banner.type === "bottomAd" || banner.type === ""
        );

        // Set the filtered banners
        setBanners(hero);
        setBottomAds(bottomAds);
      } catch (error) {
        console.error("Error fetching banners:", error);

        Swal.fire({ icon: "error", title: "Fetch Failed", text: "Could not load banners." }); 
      } finally {
        setLoading(false);
      }
    };

    fetchBanners();
  }, []);

  // --- Hero Banner Handlers (Existing) ---
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setNewBanner({ ...newBanner, file: null }); // Clear potential previous file
    setPreview("");

    if (file) {
      const img = new Image();
      img.src = window.URL.createObjectURL(file);

      img.onload = () => {
        if (img.width === HERO_BANNER_WIDTH && img.height === HERO_BANNER_HEIGHT) {
          setNewBanner({ ...newBanner, file });
          setPreview(img.src);
        } else {
         
          Swal.fire({ 
            icon: "error", 
            title: "Invalid Image Size", 
            text: `Image dimensions must be exactly ${HERO_BANNER_WIDTH}x${HERO_BANNER_HEIGHT} pixels.`
          }); 
          e.target.value = null; // Clear input field
        }
      };
    }
  };

  const handleAddBanner = async () => {
    setLoading(true);
    if (!newBanner.file || !newBanner.link) {
     
      Swal.fire({ icon: "error", title: "Fill all fields", text: "Both image and link are required." }); 
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("image", newBanner.file);
    formData.append("link", newBanner.link);
    formData.append("type", "hero");

    try {
     
      const data = await postBanner(formData); 

     
      Swal.fire({ icon: "success", title: "Hero Banner Uploaded" }); 
      setBanners((prevBanners) => [...prevBanners, data]);
      setNewBanner({ file: null, link: "" });
      setPreview("");
    } catch (error) {
      console.error("Error uploading banner:", error);
     
      Swal.fire({
        icon: "error",
        title: "Failed to upload hero banner",
        text: error.message || "An error occurred.",
      }); 
    } finally {
      setLoading(false);
    }
  };

  const handleEditBanner = (id) => {
    const bannerToEdit = banners.find((banner) => banner.id === id);
    setEditing(bannerToEdit);
    setPreview(bannerToEdit.url); 
    // Clear file input on edit start
    const fileInput = document.getElementById('heroFileInput');
    if(fileInput) fileInput.value = null;
  };

  const handleSaveEdit = async () => {
    setLoading(true);
    if (!editing.link) {
      Swal.fire({ icon: "error", title: "Link cannot be empty.", text: "Input a valid URL." }); 
      setLoading(false);
      return;
    }

    try {
      const formData = new FormData();
      formData.append("link", editing.link);
      if (editing.file) {
        formData.append("image", editing.file);
      }

      await updateBanner(editing.id, formData); 

      // Update the UI
      setBanners(
        banners.map((b) =>
          b.id === editing.id
            ? {
                ...b,
                link: editing.link,
                url: editing.file ? URL.createObjectURL(editing.file) : b.url, 
              }
            : b
        )
      );

      setEditing(null);
      setPreview("");
     
      Swal.fire({ icon: "success", title: "Banner updated successfully!" }); 
    } catch (error) {
     
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: error.message || "An unexpected error occurred.",
      }); 
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteBanner = async (id) => {
    try {
     
      await deleteBanner(id); 
      setBanners(banners.filter((banner) => banner.id !== id));
     
      Swal.fire({ icon: "success", title: "Banner deleted successfully!" }); 
    } catch (error) {
     
      Swal.fire({ icon: "error", title: "Delete Failed", text: error.message || "An error occurred." }); 
    }
  };


  // --- Bottom Ad Handlers (New) ---

  const handleFileChangeBottomAd = (e) => {
    const file = e.target.files[0];
    setNewBottomAd({ ...newBottomAd, file: null });
    setPreviewBottomAd("");

    if (file) {
      const img = new Image();
      img.src = window.URL.createObjectURL(file);

      img.onload = () => {
        if (img.width === BOTTOM_AD_WIDTH && img.height === BOTTOM_AD_HEIGHT) {
          setNewBottomAd({ ...newBottomAd, file });
          setPreviewBottomAd(img.src);
        } else {
         
          Swal.fire({ 
            icon: "error", 
            title: "Invalid Image Size for Ad", 
            text: `Image dimensions must be exactly ${BOTTOM_AD_WIDTH}x${BOTTOM_AD_HEIGHT} pixels.`
          }); 
          e.target.value = null; 
        }
      };
    }
  };

  const handleAddBottomAd = async () => {
    setLoading(true);
    if (!newBottomAd.file || !newBottomAd.link) {
     
      Swal.fire({ icon: "error", title: "Fill all fields", text: "Both image and link are required for the bottom ad." }); 
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("image", newBottomAd.file);
    formData.append("link", newBottomAd.link);
    formData.append("type", "bottomAd");

    try {
     
      const data = await postBanner(formData); 

     
      Swal.fire({ icon: "success", title: "Bottom Ad Uploaded" }); 
      setBottomAds((prevAds) => [...prevAds, data]);
      setNewBottomAd({ file: null, link: "" });
      setPreviewBottomAd("");
      
      // Clear file input
      const fileInput = document.getElementById('adFileInput');
      if(fileInput) fileInput.value = null;

    } catch (error) {
      console.error("Error uploading bottom ad:", error);
     
      Swal.fire({
        icon: "error",
        title: "Failed to upload bottom ad",
        text: error.message || "An error occurred.",
      }); 
    } finally {
      setLoading(false);
    }
  };

    // --- Bottom Ad Delete Handler ---
    const handleDeleteBottomAd = async (id) => {
        try {
          await deleteBanner(id);
          setBottomAds(bottomAds.filter((ad) => ad.id !== id));
          Swal.fire({ icon: "success", title: "Bottom Ad deleted successfully!" }); 
        } catch (error) {
          Swal.fire({ icon: "error", title: "Delete Failed", text: error.message || "An error occurred." }); 
        }
      };
    
      // --- NEW: Bottom Ad Edit Handlers ---
      const handleEditBottomAd = (id) => {
        const adToEdit = bottomAds.find((ad) => ad.id === id);
        setEditingAd(adToEdit);
        setPreviewBottomAd(adToEdit.url); 
        // Clear file input on edit start
        const fileInput = document.getElementById('adFileInput');
        if(fileInput) fileInput.value = null;
        // Clear the 'add' state when switching to edit to prevent confusion
        setNewBottomAd({ file: null, link: "" });
    };
    
      const handleSaveEditBottomAd = async () => {
          setLoading(true);
          if (!editingAd.link) {
              Swal.fire({ icon: "error", title: "Link cannot be empty.", text: "Input a valid URL." }); 
              setLoading(false);
              return;
          }
    
          try {
              const formData = new FormData();
              formData.append("link", editingAd.link);
              if (editingAd.file) {
                  formData.append("image", editingAd.file);
              }
    
              await updateBanner(editingAd.id, formData);
    
              // Update the UI
              setBottomAds(
                  bottomAds.map((ad) =>
                      ad.id === editingAd.id
                          ? {
                              ...ad,
                              link: editingAd.link,
                              url: editingAd.file ? URL.createObjectURL(editingAd.file) : ad.url, 
                          }
                          : ad
                  )
              );
    
              setEditingAd(null);
              setPreviewBottomAd("");
              Swal.fire({ icon: "success", title: "Bottom Ad updated successfully!" }); 
          } catch (error) {
              Swal.fire({
                  icon: "error",
                  title: "Update Failed",
                  text: error.message || "An unexpected error occurred.",
              }); 
          } finally {
              setLoading(false);
          }
      };
    
      const handleCancelEditBottomAd = () => {
        setEditingAd(null);
        setPreviewBottomAd("");
        setNewBottomAd({ file: null, link: "" });
      };
  
  return (
    <>
      <section className="content-main">
        <div className="content-header">
          <h2 className="content-title">Banner & Ad Management</h2>
        </div>

        {/* Hero Banner Grid Display */}
        <h3 className="mt-4 mb-3">Hero Banners ({HERO_BANNER_WIDTH}x{HERO_BANNER_HEIGHT})</h3>
        <div className="row">
          {loading ? (
            <div>Loading Banners...</div>
          ) : banners.length > 0 ? (
            banners.map((banner) => (
              <div
                key={banner.id}
                className="col-md-4 col-sm-6 mb-3 position-relative"
              >
                <div className="banner-container">
                  <img
                    src={`${baseURL}${banner.url}`}
                    alt="Banner"
                    className="img-fluid rounded shadow-sm w-100"
                    style={{ height: "150px", objectFit: "cover" }}
                    onError={(e) => { e.target.onerror = null; e.target.src="https://placehold.co/1313x501/6b7280/ffffff?text=Image+Error"; }}
                  />
                  <div className="banner-overlay">
                    <button
                      className="btn btn-warning btn-sm mx-1"
                      onClick={() => handleEditBanner(banner.id)}
                    >
                      Edit
                    </button>
                    <button
                      className="btn btn-danger btn-sm mx-1"
                      onClick={() => handleDeleteBanner(banner.id)}
                    >
                      Delete
                    </button>
                  </div>
                </div>
                <a
                  href={banner.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="d-block text-center mt-1"
                >
                  {banner.link}
                </a>
              </div>
            ))
          ) : (
            <div className="col-12 text-muted">No Hero Banners added yet.</div>
          )}
        </div>

        {/* Add/Edit Hero Banner Form (Existing) */}
        <div className="card mt-4">
          <div className="card-body">
            <h5>{editing ? "Edit Hero Banner" : "Add New Hero Banner"}</h5>
            <p className="text-muted">Required size: {HERO_BANNER_WIDTH}x{HERO_BANNER_HEIGHT} pixels.</p>
            {(preview || (editing && editing.url)) && (
              <img
                src={preview || (editing ? editing.url : "")}
                alt="Preview"
                className="img-thumbnail mb-2"
                style={{
                  width: "100%",
                  maxHeight: "200px",
                  objectFit: "cover",
                }}
              />
            )}
            <input
              type="file"
              id="heroFileInput"
              className="form-control mb-2"
              onChange={handleFileChange}
              accept="image/*"
            />
            <input
              type="text"
              className="form-control mb-2"
              placeholder="Redirect Link"
              value={editing ? editing.link : newBanner.link}
              onChange={(e) =>
                editing
                  ? setEditing({ ...editing, link: e.target.value })
                  : setNewBanner({ ...newBanner, link: e.target.value })
              }
            />
            {editing ? (
              <button disabled={loading} className="btn btn-success" onClick={handleSaveEdit}>
                {loading ? 'Saving...' : 'Save Changes'}
              </button>
            ) : (
              <button
                disabled={loading}
                className="btn btn-primary"
                onClick={handleAddBanner}
              >
                {loading ? 'Uploading...' : 'Upload Hero Banner'}
              </button>
            )}
            {editing && (
                 <button disabled={loading} className="btn btn-secondary ms-2" onClick={() => {setEditing(null); setPreview("")}}>
                    Cancel Edit
                </button>
            )}
          </div>
        </div>
        
        {/* --- Add Bottom Ad Form (New) --- */}
        <div className="card mt-5">
            <div className="card-body">
                <h5>{editingAd ? "Edit Bottom Ad" : "Add New Bottom Ad"}</h5>
                <p className="text-muted">Required size: {BOTTOM_AD_WIDTH}x{BOTTOM_AD_HEIGHT} pixels.</p>
                {/* Use the correct preview state based on mode */}
                {(previewBottomAd || (editingAd && editingAd.url)) && ( 
                    <img
                        src={previewBottomAd || (editingAd ? editingAd.url : "")}
                        alt="Ad Preview"
                        className="img-thumbnail mb-2"
                        style={{
                            width: "100%",
                            maxHeight: "100px",
                            objectFit: "contain",
                        }}
                    />
                )}
                <input
                    type="file"
                    id="adFileInput"
                    className="form-control mb-2"
                    onChange={
                      editingAd
                        ? (e) => setEditingAd({ ...editingAd, file: e.target.files[0] }) // Handle file change for edit
                        : handleFileChangeBottomAd
                    }
                    accept="image/*"
                />
                <input
                    type="text"
                    className="form-control mb-2"
                    placeholder="Redirect Link"
                    value={editingAd ? editingAd.link : newBottomAd.link}
                    onChange={(e) => 
                        editingAd 
                            ? setEditingAd({ ...editingAd, link: e.target.value }) 
                            : setNewBottomAd({ ...newBottomAd, link: e.target.value })
                    }
                />
                {editingAd ? (
                    <>
                        <button
                            disabled={loading}
                            className="btn btn-success"
                            onClick={handleSaveEditBottomAd}
                        >
                            {loading ? 'Saving...' : 'Save Changes'}
                        </button>
                        <button 
                            disabled={loading} 
                            className="btn btn-secondary ms-2" 
                            onClick={handleCancelEditBottomAd}
                        >
                            Cancel Edit
                        </button>
                    </>
                ) : (
                    <button
                        disabled={loading}
                        className="btn btn-info"
                        onClick={handleAddBottomAd}
                    >
                        {loading ? 'Uploading...' : 'Upload Bottom Ad'}
                    </button>
                )}
            </div>
        </div>

        {/* Styles for overlay buttons - Keep only necessary styling */}
        <style>{`
        .banner-container {
          position: relative;
          transition: transform 0.3s ease;
        }
        .banner-container:hover {
          transform: scale(1.02);
        }
        .banner-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          opacity: 0;
          transition: opacity 0.3s ease;
          border-radius: 0.375rem; /* Matches Bootstrap rounded */
        }
        .banner-container:hover .banner-overlay {
          opacity: 1;
        }
      `}</style>
      </section>

      {/* Bottom Ads Display Section */}
      <section className="banners my-5">
        <h3 className="container mb-3">Active Bottom Ads ({BOTTOM_AD_WIDTH}x{BOTTOM_AD_HEIGHT})</h3>
        <div className="container">
          <div className="row">
            {bottomAds && bottomAds.length > 0 ? (
              bottomAds.map((ads) => (
                <div className="col-lg-4 col-md-6 mb-4" key={ads.id}>
                  <div className="banner-container">
                    <div
                      className="banner-img wow animate__animated animate__fadeInUp"
                      data-wow-delay="0"
                    >
                      <img
                        src={
                          ads.url
                            ? baseURL+ads.url 
                            : "https://placehold.co/513x330/cccccc/333333?text=Ad+Error"
                        }
                        alt={ads.link || "Bottom Ad"}
                        className="img-fluid rounded shadow-sm"
                        style={{ width: "100%", height: "auto" }}
                        onError={(e) => { e.target.onerror = null; e.target.src="https://placehold.co/513x330/cccccc/333333?text=Ad+Error"; }}
                      />
                    </div>
                    <div className="banner-overlay">
                          <button
                            className="btn btn-warning btn-sm mx-1"
                            onClick={() => handleEditBottomAd(ads.id)}
                          >
                            Edit
                          </button>
                          <button
                            className="btn btn-danger btn-sm mx-1"
                            onClick={() => handleDeleteBottomAd(ads.id)}
                          >
                            Delete
                          </button>
                      </div>
                  </div>
                  <a href={ads.link} target="_blank" rel="noopener noreferrer" className="d-block text-center mt-1">
                      {ads.link}
                  </a>
                </div>
              ))
            ) : loading ? (
              <div className="col-12">Loading Bottom Ads...</div>
            ) : (
              <div className="col-12 text-muted">No Bottom Ads currently active.</div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default Banners;
